{
  "Non-attendance facilities":"تسهیلات غیرحضوری",
  "Requests": "درخواست‌ها",
  "Verified Users": "کاربران تایید شده",
  "Clear Filters": "حذف فیلتر‌ها",
  "Reset List": "بازنشانی لیست",
  "KYC": "KYC",
  "Mobile Verified At": "تاریخ تایید موبایل",
  "Email Verified At": "تاریخ تایید ایمیل",
  "Capabilities": "اختیارات",
  "Requirements": "الزامات",
  "Identity": "هویت",
  "Codes": "کد‌ها",
  "Referral": "معرف",
  "Password Need to Change": "نیاز به تغییر رمز عبور",
  "Referrer Code": "کد معرف",
  "Passport Number": "شماره گذرنامه",
  "Foreigners": "اتباع خارجی‌",
  "Is Legal User": "کاربر قانونی",
  "Legal National ID": "کد ملی قانونی",
  "Verified At": "تاریخ تایید",
  "Date": "تاریخ",
  "From Date": "از تاریخ",
  "To Date": "تا تاریخ",
  "User ID": "شناسه کاربر",
  "KYC Level": "سطح KYC",
  "KYC Done": "KYC تکمیل شده",
  "Is Active": "فعال است",
  "Is Locked": "قفل شده است",
  "Has Two FA": "دو فاکتوری",
  "Email Verification Code": "کد تایید ایمیل",
  "Mobile Verification Code": "کد تایید شماره موبایل",
  "Can Deposit": "امکان واریز",
  "Can Withdraw": "امکان برداشت",
  "Can Trade": "امکان معامله",
  "Has Disability": "معلولیت",
  "Need To Track": "نیاز به پیگیری",
  "Need To Change Password": "نیاز به تغییر رمز عبور",
  "Verification Code": "کد تایید",
  "Done": "انجام شده",
  "Level": "سطح",
  "Need to Track": "نیاز به پیگیری",
  "Locked": "مسدود",
  "Two Factor Login": "ورود دو مرحله‌ای",
  "User Menu": "منو کاربری",
  "This admin is not active.": "این مدیر فعال نیست.",
  "Do you want to save the changes?": "آیا مطمئن هستید که می‌خواهید تغییرات را ذخیره کنید؟",
  "Save Changes": "ذخیره کردن تغییرات",
  "You": "شما",
  "To complete the two-factor authentication setup, scan the QR code above by google authenticator app and then enter the generated code in the field below.": "برای فعال سازی احراز هویت دو مرحله‌ای، کد QR بالا را با اپلیکیشن Google Authenticator اسکن کرده و سپس کد تولید شده را وارد نمایید.",
  "Enable Two Step Verification": "فعال سازی احراز هویت دو مرحله‌ای",
  "Security Setting": "تنظیمات امنیتی",
  "User Data": "اطلاعات کاربری",
  "View Admin": "مشاهده مدیر",
  "Role": "نقش",
  "Status": "وضعیت",
  "Last Change Password": "آخرین تغییر پسورد",
  "Initial Password Update": "به روز رسانی اولیه رمز عبور",
  "New Admin": "مدیر جدید",
  "Changes Not Saved.": "تغییرات انجام نشدند.",
  "Data Updated Successfully": "تغییرات با موفقیت انجام شدند.",
  "This field is required": "وارد کردن این فیلد اجباری ست.",
  "Passwords You Entered Do Not Match.": "رمزهای عبوری که وارد کرده‌اید با یکدیگر همخوانی ندارند.",
  "Password Changed Successfully": "رمز عبور با موفقیت تغییر کرد.",
  "Password Change failed.": "تغییر رمز عبور انجام نشد.",
  "Mobile": "موبایل",
  "Last Name": "نام خانوادگی",
  "Alias": "نام مستعار",
  "Is": "است",
  "Active": "فعال",
  "Save": "ذخیره",
  "Changes": "تغییرات",
  "Add New Admin": "اضافه کردن مدیر جدید",
  "Change Password": "تغییر رمز عبور",
  "Current Password": "رمز عبور فعلی",
  "Confirm New Password": "تکرار رمز عبور جدید",
  "Profile": "پروفایل",
  "Admin Profile": "پروفایل مدیر",
  "Update Password": "تغییر رمز عبور",
  "User Agent": "واسط کاربر",
  "Device": "دستگاه",
  "Browser": "مرورگر",
  "Country": "کشور",
  "IP": "آدرس IP",
  "Time": "زمان",
  "New Admin Creation failed.": "اضافه کردن مدیر جدید انجام نشد.",
  "New Admin Created Successfully.": "اضافه کردن مدیر جدید با موفقیت انجام شد.",
  "Email field is required": "فیلد ایمیل اجباری است",
  "The Email field must be a valid email": "فیلد ایمیل باید یک ایمیل معتبر باشد",
  "Field must contain at least one uppercase, lowercase, special character and digit with min 8 chars": "فیلد باید حداقل یک حرف بزرگ، یک حرف کوچک، یک کاراکتر ویژه و یک عدد با حداقل ۸ کاراکتر باشد",
  "The Confirm Password field confirmation does not match": "تأیید رمز عبور مطابقت ندارد",
  "Enter number between ${min} and ${max}": "عدد باید بین ${min} و ${max} باشد",
  "This field must be an integer": "این فیلد باید یک عدد صحیح باشد",
  "The Regex field format is invalid": "فرمت فیلد عبارت منظم نامعتبر است",
  "The Alpha field may only contain alphabetic characters": "فیلد حروف الفبا فقط می‌تواند شامل حروف الفبا باشد",
  "URL is invalid": "آدرس URL نامعتبر است",
  "The Min Character field must be at least ${length} characters": "فیلد باید حداقل ${length} کاراکتر باشد",
  "All Character are not valid": "تمامی کاراکترها معتبر نمی‌باشند",
  "Password must contain at least one special character (!#$%^&*()_+[]:;<>,.?~)": "رمز عبور باید حداقل یک کاراکتر ویژه داشته باشد (!#$%^&*()_+[]:;<>,.?~).",
  "Password must contain at least one digit.": "رمز عبور باید حداقل یک عدد داشته باشد.",
  "Password must contain at least one uppercase letter.": "رمز عبور باید حداقل یک حرف بزرگ داشته باشد.",
  "Password must be at least 8 characters long.": "رمز عبور باید حداقل ۸ کاراکتر باشد.",
  "Login History": "سوابق ورود",
  "Family": "نام خانوادگی",
  "Super Admin": "سوپر ادمین",
  "Logout": "خروج",
  "Submit": "ارسال",
  "Reset": "بازنشانی",
  "Advanced Search": "جستجوی پیشرفته",
  "Not registered?": "ثبت نام نکرده اید؟",
  "Create an account": "ساخت حساب",
  "Password": "رمز ورود",
  "Please sign-in to your account and start the adventure": "لطفاً وارد حساب کاربری خود شوید.",
  "Welcome to": "خوش آمدید به",
  "Panel": "پنل مدیریت",
  "Back to login": "بازگشت به صفحه ورود",
  "Set New Password": "ثبت رمز عبور جدید",
  "Confirm Password": "تکرار رمز عبور",
  "New Password": "رمز عبور جدید",
  "for": "برای",
  "Edit Admin": "ویرایش مدیر",
  "Deposit List": "لیست واریز ها",
  "Fav": "مورد علاقه",
  "Auto": "خودکار",
  "Symbol": "نماد",
  "Network": "شبکه",
  "Network handle": "دستگیره شبکه",
  "From": "از",
  "To": "به",
  "Confirmation": "تأیید",
  "ACTIONS": "اقدامات",
  "Disable Admin": "غیرفعال کردن مدیر",
  "Add Admin": "اضافه کردن مدیر",
  "Open Orders List": "لیست سفارش‌های باز",
  "Closed Orders List": "لیست سفارش‌های بسته",
  "Trades List": "لیست ترید‌ها",
  "Order Trades List": "لیست ترید‌های سفارش",
  "Order Info": "اطلاعات سفارش",
  "Cancel Order": "لغو سفارش",
  "Orders List": "لسیت سفارش‌ها",
  "Admins List": "لسیت مدیر‌ها",
  "Admin Panel": "پنل مدیریت",
  "Deposits List": "لیست واریزها",
  "Withdraw": "برداشت",
  "Withdraws List": "لیست برداشت‌ها",
  "Bank Cards": "کارت های بانکی",
  "View User": "مشاهده کاربر",
  "Edit User": "ویرایش کاربر",
  "Wallets": "کیف پول",
  "Transaction Record": "ثبت تراکنش",
  "Miscellaneous operations (resetting password, etc.)": "عملیات‌های متفرقه (ریست کردن رمز عبور و ...)",
  "Balance": "موجودی",
  "Confirm Delete": "آیا مطمئن هستید که می خواهید این مورد را حذف کنید؟",
  "Ok": "تایید",
  "Cancel": "لغو",
  "Search": "جستجو",
  "Deposit": "واریز",
  "Name": "نام",
  "Select Role": "انتخاب نقش",
  "Users": "کاربر‌ها",
  "Users List": "لسیت کاربر‌ها",
  "Admins": "مدیر‌ها",
  "Admin": "مدیر",
  "Orders": "سفارش‌ها",
  "Deposits": "واریزها",
  "Withdraws": "برداشت ها",
  "UI Elements": "عناصر رابط کاربری",
  "Forms & Tables": "فرم‌ها و جداول",
  "Pages": "صفحات",
  "Charts & Maps": "نمودارها و نقشه‌ها",
  "Others": "دیگر موارد",
  "Typography": "تایپوگرافی",
  "Cards": "کارت‌ها",
  "Basic": "پایه",
  "Advance": "پیشرفته",
  "Widgets": "ابزارک‌ها",
  "Components": "کامپوننت‌ها",
  "Alert": "هشدار",
  "Close Alert": "بستن هشدار",
  "Avatar": "نمایه",
  "Badge": "نشان",
  "Button": "دکمه",
  "Calendar": "تقویم",
  "Image": "تصویر",
  "Pagination": "صفحه‌بندی",
  "Progress Circular": "پیشرفت دایره‌ای",
  "Progress Linear": "پیشرفت خطی",
  "Autocomplete": "تکمیل خودکار",
  "Tooltip": "راهنمای ابزار",
  "Slider": "اسلایدر",
  "Date Time Picker": "انتخاب تاریخ و زمان",
  "Select": "انتخاب",
  "Switch": "سوییچ",
  "Checkbox": "چک باکس",
  "Radio": "رادیو",
  "Textarea": "ناحیه متنی",
  "Rating": "امتیازدهی",
  "File Input": "انتخاب فایل",
  "Otp Input": "ورودی اعتبار دومی",
  "Form Layout": "طرح فرم",
  "Form Validation": "اعتبارسنجی فرم",
  "Charts": "نمودارها",
  "Apex Chart": "نمودار Apex",
  "Chartjs": "نمودار Chartjs",
  "Account Settings": "تنظیمات حساب کاربری",
  "User Profile": "پروفایل کاربری",
  "FAQ": "سوالات متداول",
  "Dialog Examples": "مثال‌های دیالوگ",
  "Pricing": "قیمت‌گذاری",
  "List": "لیست",
  "Edit": "ویرایش",
  "Nav Levels": "سطوح ناوبری",
  "Level 2.1": "سطح 2.1",
  "Level 2.2": "سطح 2.2",
  "Level 3.1": "سطح 3.1",
  "Level 3.2": "سطح 3.2",
  "Raise Support": "درخواست پشتیبانی",
  "Documentation": "مستندات",
  "Dashboards": "پنل تسهیلات",
  "Analytics": "تجزیه و تحلیل",
  "Apps & Pages": "برنامه‌ها و صفحات",
  "Email": "ایمیل",
  "Chat": "چت",
  "Invoice": "فاکتور",
  "Preview": "پیش‌نمایش",
  "Add": "افزودن",
  "User": "کاربر",
  "View": "مشاهده",
  "Login v1": "ورود نسخه 1",
  "Login v2": "ورود نسخه 2",
  "Login": "ورود",
  "Register v1": "ثبت نام نسخه 1",
  "Register v2": "ثبت نام نسخه 2",
  "Register": "ثبت نام",
  "Forget Password v1": "فراموشی رمز عبور نسخه 1",
  "Forget Password v2": "فراموشی رمز عبور نسخه 2",
  "Forgot Password v1": "رمز عبور فراموش شده نسخه 1",
  "Forgot Password v2": "رمز عبور فراموش شده نسخه 2",
  "Forgot Password": "فراموشی رمز عبور",
  "Reset Password v1": "بازیابی رمز عبور نسخه 1",
  "Reset Password v2": "بازیابی رمز عبور نسخه 2",
  "Reset Password": "بازیابی رمز عبور",
  "Miscellaneous": "متفرقه",
  "Coming Soon": "به زودی",
  "Not Authorized": "مجوز ندارد",
  "Under Maintenance": "تحت تعمیر و نگهداری",
  "Error": "خطا",
  "Statistics": "آمار",
  "Actions": "اقدامات",
  "Access Control": "کنترل دسترسی",
  "User Interface": "رابط کاربری",
  "CRM": "مدیریت ارتباط با مشتریان",
  "eCommerce": "تجارت الکترونیک",
  "Icons": "آیکون‌ها",
  "Chip": "تراشه",
  "Dialog": "دیالوگ",
  "Expansion Panel": "پنل گسترش",
  "Combobox": "جعبه‌متن",
  "Textfield": "فیلد متنی",
  "Range Slider": "اسلایدر محدوده",
  "Menu": "منو",
  "Snackbar": "پیغام سریع",
  "Tabs": "تب‌ها",
  "Form Elements": "عناصر فرم",
  "Form Layouts": "طرح‌های فرم",
  "Authentication": "احراز هویت",
  "Page Not Found - 404": "صفحه پیدا نشد - 404",
  "Not Authorized - 401": "عدم مجوز - 401",
  "Server Error - 500": "خطای سرور - 500",
  "2": "2",
  "Forms": "فرم‌ها",
  "Timeline": "جدول زمانی",
  "Disabled Menu": "منو غیرفعال",
  "Help Center": "مرکز راهنما",
  "Verify Email": "تأیید ایمیل",
  "Verify Email v1": "تأیید ایمیل نسخه 1",
  "Verify Email v2": "تأیید ایمیل نسخه 2",
  "Two Steps": "دو مرحله‌ای",
  "Two Steps v1": "دو مرحله‌ای نسخه 1",
  "Two Steps v2": "دو مرحله‌ای نسخه 2",
  "Custom Input": "ورودی سفارشی",
  "Extensions": "افزونه‌ها",
  "Tour": "تور",
  "Register Multi-Steps": "ثبت نام چند مرحله‌ای",
  "Wizard Examples": "مثال‌های ویزارد",
  "Checkout": "پرداخت",
  "Create Deal": "ایجاد معامله",
  "Property Listing": "لیست ملک‌ها",
  "Roles & Permissions": "نقش‌ها و مجوزها",
  "Roles": "نقش‌ها",
  "Simple Table": "جدول ساده",
  "Tables": "جداول",
  "Data Table": "جدول داده",
  "Permissions": "مجوزها",
  "Apps": "برنامه‌ها",
  "Misc": "متفرقه",
  "Wizard Pages": "صفحات ویزارد",
  "Form Wizard": "ویزارد فرم",
  "Numbered": "شماره‌گذاری شده",
  "3": "3",
  "ecommerce": "تجارت الکترونیک",
  "Ecommerce": "تجارت الکترونیک",
  "Editors": "ویرایشگرها",
  "Front Pages": "صفحات اصلی",
  "Landing": "فرود",
  "checkout": "پرداخت",
  "Payment": "پرداخت",
  "Swiper": "اسلایدر",
  "Product": "محصول",
  "Category": "دسته‌بندی",
  "Order": "سفارش",
  "Details": "جزئیات",
  "Customer": "مشتری",
  "Manage Review": "مدیریت نقد و بررسی",
  "Referrals": "معرفی‌ها",
  "Settings": "تنظیمات",
  "Overview": "بررسی کلی",
  "My Course": "دوره من",
  "Course Details": "جزئیات دوره",
  "Academy": "آموزشگاه",
  "Logistics": "لجستیک",
  "Dashboard": "پنل تسهیلات شعبه مجازی",
  "Fleet": "ناوگان",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "$vuetify": {
    "badge": "نشان",
    "noDataText": "داده موجود نیست",
    "close": "بستن",
    "open": "باز کردن",
    "carousel": {
      "ariaLabel": {
        "delimiter": "جداکننده"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "تعداد موارد در هر صفحه:",
      "itemsPerPageAll": "همه",
      "pageText": "{0}-{1} از {2}",
      "firstPage": "صفحه اول",
      "prevPage": "صفحه قبلی",
      "nextPage": "صفحه بعدی",
      "lastPage": "آخرین صفحه"
    },
    "pagination": {
      "ariaLabel": {
        "root": "ریشه",
        "previous": "قبلی",
        "next": "بعدی",
        "currentPage": "صفحه فعلی",
        "page": "صفحه"
      }
    },
    "input": {
      "clear": "پاک کردن",
      "appendAction": "اقدام پسوند",
      "prependAction": "اقدام پیشوند",
      "counterSize": "اندازه شمارنده",
      "otp": "کد یکبار مصرف"
    },
    "fileInput": {
      "counterSize": "اندازه شمارنده"
    },
    "rating": {
      "ariaLabel": {
        "item": "مورد"
      }
    }
  }
}
